// Scores
export const linkingScoreWeights = [
  50, // Internal/External Links Ratio
  50, // Link Placement
];

export const linkingScoreWeightsWithCompetitor = [
  25, // Internal/External Links Ratio
  25, // Link Placement
  25, // Anchor Text Type Score
  25, // Anchor Length Score
];

export const linkingScoreWeightsWithSingleAnchor = [
  40, // Internal/External Links Ratio
  40, // Link Placement
  20, // Anchor Text Type Score
];

//   Get Links
export const getLinks = (htmlContent) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlContent, "text/html");

  const links = doc.querySelectorAll("a");
  return links;
};

// Calculate Internal/External Link Ratio
export const calculateLinkRatio = (nb_internalLinks, nb_exteralLinks) => {
  const ratio =
    nb_exteralLinks === 0
      ? nb_internalLinks
      : nb_internalLinks / nb_exteralLinks;
  if (nb_exteralLinks == 0 && nb_internalLinks == 0) {
    return 0;
  }
  if (ratio < 2 || ratio > 4) {
    return 50;
  }
  if (ratio >= 2 && ratio <= 4) {
    return 100;
  }
};

// Calculate Link Distribution Score
export const calculateLinkDistributionScore = (score) => {
  if (score > 0.00004 || score === 0) {
    return 0;
  }
  if (score >= 0.00002 && score < 0.00004) {
    return 50;
  }
  if (score < 0.00002) {
    return 100;
  }
};

// Calculate color of keyword
export const calculateKeywordsColor = (branded, keywords) => {
  if (branded + keywords > 80 && Math.abs(branded - keywords) < 30) {
    return "text-green-500";
  }

  if (branded + keywords > 80 && Math.abs(branded - keywords) > 30) {
    if (keywords > branded) {
      return "text-green-500";
    } else {
      return "text-yellow-500";
    }
  }

  if (branded + keywords > 60 && Math.abs(branded - keywords) < 30) {
    return "text-green-500";
  }

  if (branded + keywords > 60 && Math.abs(branded - keywords) > 30) {
    if (keywords > branded) {
      return "text-green-500";
    } else {
      return "text-red-600";
    }
  }
  if (branded + keywords > 40) {
    return "text-yellow-500";
  } else {
    return "text-red-600";
  }
};

// Caluclate color of branded keyword
export const calculateBrandedColor = (branded, keywords) => {
  if (branded + keywords > 80 && Math.abs(branded - keywords) < 30) {
    return "text-green-500";
  }

  if (branded + keywords > 80 && Math.abs(branded - keywords) > 30) {
    if (branded > keywords) {
      return "text-green-500";
    } else {
      return "text-yellow-500";
    }
  }

  if (branded + keywords > 60 && Math.abs(branded - keywords) < 30) {
    return "text-green-500";
  }

  if (branded + keywords > 60 && Math.abs(branded - keywords) > 30) {
    if (branded > keywords) {
      return "text-green-500";
    } else {
      return "text-red-600";
    }
  }
  if (branded > 40 || keywords > 40) {
    return "text-yellow-500";
  } else {
    return "text-red-600";
  }
};
